class TerminalsLocationApp {
  constructor(element, markers) {
    this.element = element;
    this.markers = this.createMarkerPresenters(markers);
    this.map = new window.google.maps.Map(element, this.mapOptions());
    this.mapMarkers = this.createMarkersInMap();
    this.createInfoWindowsInMap();
    this.resizeMap();
  }

  mapOptions() {
    return {
      scrollwheel: false,
      zoom: 13,
      zoomControl: true,
      center: this.defaultCenter(),
    };
  }

  createMarkersInMap() {
    return this.markers.map((marker, index) => {
      const markerOptions = {
        position: marker.location(),
        map: this.map,
        markerIndex: index,
        label: { text: `${marker.legend}`, color: "white" },
      };

      if (marker.icon) markerOptions.icon = marker.icon;
      if (marker.title) markerOptions.title = marker.title;
      if (marker.zIndex) markerOptions.zIndex = marker.zIndex;

      return new window.google.maps.Marker(markerOptions);
    });
  }

  createInfoWindowsInMap() {
    this.mapMarkers.forEach((mapMarker) => {
      if (!mapMarker.getTitle()) return;

      const infoWindow = new window.google.maps.InfoWindow({
        content: mapMarker.getTitle(),
        maxWidth: 230,
      });

      mapMarker.addListener("click", () => infoWindow.open(this.map, mapMarker));
    });
  }

  resizeMap() {
    if (this.markers.length <= 1) return;

    const bounds = new window.google.maps.LatLngBounds();
    this.markers.forEach((marker) => bounds.extend(marker.location()));
    this.map.fitBounds(bounds);
  }

  createMarkerPresenters(markers) {
    return markers.map((marker) => ({
      ...marker,
      location() {
        return new window.google.maps.LatLng(this.lat, this.long);
      },
    }));
  }

  defaultCenter() {
    return this.markers[0]?.location() || new window.google.maps.LatLng(19.4326077, -99.13320799999997);
  }
}

window.TerminalsLocationApp = TerminalsLocationApp;
